import { createContext, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { LANGUAGE_STORAGE_KEY, SUPPORTED_LANGUAGES } from "../i18n";

const LanguageContext = createContext({
    language: "az",
    setLanguage: () => {},
    supportedLanguages: SUPPORTED_LANGUAGES,
});

export const LanguageProvider = ({ children }) => {
    const { i18n } = useTranslation();
    const [language, setLanguageState] = useState(
        () => localStorage.getItem(LANGUAGE_STORAGE_KEY) || i18n.language || "az"
    );

    useEffect(() => {
        if (i18n.language !== language) {
            i18n.changeLanguage(language);
        }
    }, [language, i18n]);

    const setLanguage = (lng) => {
        if (!SUPPORTED_LANGUAGES.find((l) => l.code === lng)) return;
        localStorage.setItem(LANGUAGE_STORAGE_KEY, lng);
        setLanguageState(lng);
        i18n.changeLanguage(lng);
    };

    return (
        <LanguageContext.Provider
            value={{ language, setLanguage, supportedLanguages: SUPPORTED_LANGUAGES }}
        >
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => useContext(LanguageContext);
